import getAuthenticationRedirectUrl from "./getAuthenticationRedirectUrl";

export default function redirectToSignInPage(props?: {
    allowAutoLogin?: boolean;
}): void {
    const redirectUrl = getAuthenticationRedirectUrl(props);
    window.location.replace(redirectUrl);
}
